import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  ChipPropsVariantOverrides,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { DateTime } from "luxon";
import { useState } from "react";
import { MediumCustomIcon } from "../../layer00";
import { CalendarAppointmentCard } from "../../layer19";

export type CalendarAppointmentsAccordionProps = {
  aptDate: DateTime;
  events: {
    id: string;
    aptTime: DateTime;
    aptName: string;
    aptState: keyof ChipPropsVariantOverrides;
    meetingId: number;
    webLink?: string | null;
    userConfirmed?: boolean;
    userAccountId?: number | null;
    report?: {
      id: string;
    };
  }[];
};

export const CalendarAppointmentsAccordion = (
  props: CalendarAppointmentsAccordionProps
) => {
  const theme = useTheme();
  const [expanded, setExpanded] = useState(true);
  return (
    <Accordion
      onChange={() => setExpanded((prev) => !prev)}
      expanded={expanded}
      sx={{
        "&::before": {
          display: "none",
        },
      }}
    >
      {/* TITLE */}
      <AccordionSummary
        expandIcon={
          <MediumCustomIcon
            icon="CHEVRONDOWN"
            stroke={theme.palette.secondary.light}
          />
        }
        sx={{
          minHeight: "4.5rem",
          "&.Mui-expanded": {
            minHeight: "4.5rem",
          },
          "& .MuiAccordionSummary-content": {
            margin: 0,
            alignItems: "center",
          },
          "& .MuiAccordionSummary-content.Mui-expanded": {
            margin: 0,
          },
        }}
      >
        <Stack direction="row" columnGap=".5rem">
          <Typography variant="cardTitle">
            {props.aptDate.toLocal().toLocaleString({
              weekday: "long",
              month: "long",
              day: "numeric",
            })}
          </Typography>
          <Chip
            variant="info"
            label={`${props.events.length} ${
              props.events.length === 1 ? "Meeting" : "Meetings"
            }`}
          />
        </Stack>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          display: "flex",
          flexDirection: "column",
          rowGap: "1.5rem",
          marginTop: "0.75rem",
          marginBottom: "1rem",
          paddingTop: 0,
          paddingBottom: 0,
        }}
      >
        {props.events.map((event) => (
          <CalendarAppointmentCard
            key={event.id}
            id={event.id}
            aptTime={event.aptTime}
            aptName={event.aptName}
            aptState={event.aptState}
            meetingId={event.meetingId}
            webLink={event.webLink}
            userConfirmed={event.userConfirmed}
            userAccountId={event.userAccountId}
          />
        ))}
      </AccordionDetails>
    </Accordion>
  );
};
